import { Button } from 'antd';
import { useEffect, useState } from 'react';

import styles from './profile.module.scss';
import { Link, Outlet } from 'react-router-dom';
import Icon from 'utils/icon';
import avatar from 'assets/images/avatar.png';
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import ProfileBillingDetailsComponent from '../billing-details/billing-details';
import ProfileBillingCardsComponent from '../billing-cards/billing-cards';
import ProfileBillingHistoryComponent from '../billing-history/billing-history';
import ProfileBillingAddressesComponent from '../billing-addresses/billing-addresses';

interface ProfileBillingProps {
	name: string;
	contact: string;
	country: string;
}

function ProfileBillingComponent() {
	return (
		<>
			<ProfileBillingDetailsComponent />

			<ProfileBillingCardsComponent />

			<ProfileBillingAddressesComponent />

			<ProfileBillingHistoryComponent />
		</>
	);
}

export default ProfileBillingComponent;
